import React from "react";

import {
  BottomBackground,
  Container,
  ContentWrapper,
  FooterContent,
  Wrapper,
} from "./styles";

type Props = {
  leftContent: React.ReactNode;
  centerContent: React.ReactNode;
  rightContent: React.ReactNode;
  bottomContent: React.ReactNode;
  disabled?: boolean;
};

const Footer: React.FC<Props> = ({
  leftContent,
  centerContent,
  rightContent,
  bottomContent,
  disabled,
}) => {
  return (
    <Container disabled={disabled}>
      <Wrapper isTop>
        <FooterContent isTop>
          <ContentWrapper>{leftContent}</ContentWrapper>
          <ContentWrapper>{centerContent}</ContentWrapper>
          <ContentWrapper>{rightContent}</ContentWrapper>
        </FooterContent>
      </Wrapper>

      <Wrapper>
        <BottomBackground />
        <FooterContent isBottom>{bottomContent}</FooterContent>
      </Wrapper>
    </Container>
  );
};

export default Footer;
